import router from "@/plugins/router"
import { RouteLocationRaw } from "vue-router"
import { IAuthService, AuthService } from "@/services/AuthService"
import { PermissionsService, Permission } from "@/services/PermissionsService"

export const getUserPermissions = {
  hasPermission(
    permission: Permission,
    authService: IAuthService = AuthService,
  ): boolean {
    const roles = authService.getUserRoles()
    return PermissionsService.hasPermission(permission, roles)
  },
  hasAllPermissions(
    permissions: Permission[],
    authService: IAuthService = AuthService,
  ): boolean {
    const roles = authService.getUserRoles()
    return PermissionsService.hasAllPermissions(permissions, roles)
  },
  hasAnyPermission(
    permissions: Permission[],
    authService: IAuthService = AuthService,
  ): boolean {
    const roles = authService.getUserRoles()
    return PermissionsService.hasAnyPermission(permissions, roles)
  },
  canAccessRoute(
    route: RouteLocationRaw,
    authService: IAuthService = AuthService,
  ): boolean {
    const permissionsRequired = router.resolve(route).meta.permissions || []
    const roles = authService.getUserRoles()
    return PermissionsService.hasAllPermissions(permissionsRequired, roles)
  },
  hasCustSearchPermission(authService: IAuthService = AuthService): boolean {
    const roles = authService.getUserRoles()
    return PermissionsService.hasCustSearchPermission(roles)
  },
}
